import * as React from 'react';
import { memo } from 'react';

const SvgCalendarPlus = (props) => (React.createElement("svg", Object.assign({ width: "1em", height: "1em", viewBox: "0 0 21 21", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M17.121 3.616h-12.5a.625.625 0 0 0-.625.625v12.5c0 .345.28.625.625.625h12.5c.345 0 .625-.28.625-.625v-12.5a.625.625 0 0 0-.625-.625ZM14.621 2.366v2.5M7.121 2.366v2.5M3.996 7.366h13.75M13.059 12.366H8.684M10.871 10.179v4.375", stroke: "currentColor", strokeWidth: 1.2, strokeLinecap: "round", strokeLinejoin: "round" })));
const Memo = memo(SvgCalendarPlus);

export { Memo as default };
